import React from 'react';
import loadable from '@loadable/component';
import { WaypointLazyRender } from '../../../../components/WaypointLazyRender';

const CollectionsBucketContainer = loadable(() =>
    import('./CollectionsBucketContainer'),
);

export const LazyLoadedCollectionsBucket = () => {
    return (
        <WaypointLazyRender>
            <CollectionsBucketContainer />
        </WaypointLazyRender>
    );
};
